<template>
  <div>
    <v-card-subtitle v-if="language !== null">{{ t({s: `${language}`, component: 'lang' }) }}</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col v-for="(file, key) in data" :key="key" class="d-flex child-flex" cols="2" md="4" lg="3" xl="2">
          <File :slug="file.tag" :title="file.title" v-if="type === 'document' || type === 'image'" :type="type"/>
          <Video :id="file.tag" :title="file.title" v-if="type === 'video'"/>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import File from '@/components/Information/File/index.vue'
import Video from '@/components/Information/Video/index.vue'

export default {
  name: 'Card',
  components: { Video, File },
  props: {
    data: Array[{
      tag: String,
      title: String
    }],
    language: String,
    type: String
  }
}
</script>

<style scoped>@import './styles.css';</style>
